import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { navigationTabs, routes } from '../../../../routes/constants';
import {
  Navigation,
  AccountContainer,
  LargeAccountIcon,
  AccountHeader,
  AccountEmail,
  NavigationContainer
} from './DesktopNavBar.styles';
import { personalDetailsSelectors } from '../../../../tabs/PersonalDetails/ducks';
import DesktopNavigationItem from './DesktopNavigationItem';
import { sharedSelectors } from '../../../ducks';
import { toTitleCase, trimDash } from '../../../../utilities';
import type { TabFeatureFlags } from '../../../../contracts';
import type { RootState } from '../../../../store/types';

type StateProps = {
  emailAddress: string;
  firstName: string;
  tabFeatureFlags: TabFeatureFlags;
};

function DesktopNavBar({ firstName, emailAddress, tabFeatureFlags }: StateProps) {
  const firstNameDisplay = toTitleCase(firstName);
  const shouldTruncateFirstName = firstNameDisplay.length > 13;
  const shouldShowEmail = emailAddress.length < 20;
  const truncatedFirstNameDisplay = () => {
    return shouldTruncateFirstName ? (
      <div>
        {' '}
        {trimDash(firstNameDisplay.substring(0, 13))}
        ...!
      </div>
    ) : (
      <span> {firstNameDisplay}!</span>
    );
  };

  return (
    <Navigation>
      <AccountContainer>
        <LargeAccountIcon />
        <AccountHeader className={classnames({ 'is-center': shouldTruncateFirstName })}>
          Hello {truncatedFirstNameDisplay()}
        </AccountHeader>
        {shouldShowEmail && <AccountEmail>{emailAddress}</AccountEmail>}
      </AccountContainer>
      <NavigationContainer>
        {/* Dont add anymore filters until https://jira.carvana.com/browse/CORE-6550 is resolved */}
        {navigationTabs
          .filter((tab) => {
            const routeDetails = routes[tab.path] || {};
            const { featureFlag } = routeDetails;
            return featureFlag
              ? (tabFeatureFlags[routeDetails.featureFlag as keyof TabFeatureFlags] ?? false)
              : true;
          })
          .map((tab) => (
            <DesktopNavigationItem tab={tab} key={tab.path} />
          ))}
      </NavigationContainer>
    </Navigation>
  );
}

const mapStateToProps = (state: RootState) => ({
  firstName: personalDetailsSelectors.getFirstName(state),
  emailAddress: personalDetailsSelectors.getEmailAddress(state),
  tabFeatureFlags: sharedSelectors.getTabFeatureFlags(state)
});

export default connect(mapStateToProps)(DesktopNavBar);
